import React from "react";

import "./UserCoupons.scss";

const UserCoupons = () => (
  <div id="user-coupons">
    <img src="/theme/img/coupon-design.jpg" alt="La jornada cupón" />
  </div>
);

export default UserCoupons;
